export default __webpack_public_path__ + "static/media/notification_settings_bell_red.0a98d8d1.svg";